import React from "react";
import { Link as ScrollLink } from "react-scroll"; // pour smooth scroll
import logo from "../assets/logo.png";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

const navItems = [
  { title: "Accueil", path: "home" },
  { title: "Accompagner", path: "accompagner" },
  { title: "Services", path: "services" },
  { title: "Tarifs", path: "tarifs" },
];

const servicesList = [
  "Création devis",
  "Facture",
  "Gérer vos clients",
  "Inviter comptable",
  "Relancer vos clients",
];

const Footer = () => {
  return (
    <footer className="bg-color1 text-white pt-10 pb-6 w-full">
      <div className="xl:px-28 px-4">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-8">
          {/* Logo & Description */}
          <div className="flex flex-col items-start gap-2 lg:w-1/3 w-full">
            <a href="/">
              <img
                src={logo}
                className="h-full w-auto max-h-20 lg:max-h-28"
                alt="gestion freelance"
              />
            </a>
            <p className="font-Poppins text-justify font-medium text-xs">
              Notre plateforme a été pensée pour la nouvelle génération de freelances et d’indépendants. Nous créons un espace de gestion plus simple et plus efficace, partout dans le monde.
            </p>
          </div>

          {/* Raccourcis */}
          <div className="flex flex-col gap-2">
            <h4 className="font-Poppins font-semibold lg:text-md text-sm hover:text-color7">
              Raccourcis
            </h4>
            {navItems.map((item, index) => (
              <ScrollLink
                key={index}
                to={item.path}
                smooth={true}
                duration={500}
                className="font-Poppins font-medium cursor-pointer text-xs underline hover:text-color7"
                spy={true}
                offset={-70}
              >
                {item.title}
              </ScrollLink>
            ))}
          </div>

          {/* Services */}
          <div className="flex flex-col gap-2">
            <h4 className="font-Poppins font-semibold lg:text-md text-sm hover:text-color7">
              Services
            </h4>
            {servicesList.map((service, index) => (
              <p
                key={index}
                className="font-Poppins font-medium cursor-default text-xs hover:text-color7"
              >
                {service}
              </p>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-2">
            <h4 className="font-Poppins font-semibold lg:text-md text-sm hover:text-color7">
              Contactez-nous
            </h4>
            <p className="font-Poppins font-medium text-xs hover:text-color7">
              contact@gestionfreelance.com
            </p>
            <p className="font-Poppins font-medium text-xs hover:text-color7">
              Lyon 69000
            </p>
          </div>

          {/* Réseaux sociaux */}
          <div className="flex flex-col gap-2">
            <h4 className="font-Poppins font-semibold lg:text-md text-sm hover:text-color7">
              Suivez-nous
            </h4>
            <div className="flex items-center gap-4 pt-2">
              <FaFacebookF className="cursor-pointer hover:text-color7" size={23} />
              <FaInstagram className="cursor-pointer hover:text-color7" size={23} />
              <FaTiktok className="cursor-pointer hover:text-color7" size={23} />
            </div>
          </div>
        </div>

        <hr className="w-full mt-10 border-color2" />

        {/* Bloc des politiques & Copyright */}
        <div className="flex flex-col lg:flex-row lg:justify-between items-center mt-4 gap-3">
          <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-xs">
            <a href="/mentions-legales" className="font-Poppins font-medium hover:text-color3">
              Mentions légales
            </a>
            <a href="/conditions-ventes" className="font-Poppins font-medium hover:text-color3">
              Conditions générales de ventes
            </a>
            <a href="/politique-confidentialite" className="font-Poppins font-medium hover:text-color3">
              Politiques de confidentialité
            </a>
            <a href="/politique-cookies" className="font-Poppins font-medium hover:text-color3">
              Politique Cookies
            </a>
            <a href="/declaration-accessibilite" className="font-Poppins font-medium hover:text-color3">
              Déclaration Accessibilité
            </a>
          </div>

          <p className="text-xs font-extralight font-Poppins text-color2 text-center lg:text-left">
            Copyright © Gestion Freelance
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
